module.exports = __webpack_public_path__ + "media/images/area-info2-01b4631a.png";